import { PlainDate, getCurrentDate } from "@sa-nu/shared-utils/date";
import { RESERVATION_RULE_REVISION_2027_START_DATE } from "@sa-nu/shared-utils/reservation-rule-2027";

// 各種規約系の URL
export const LEGAL_DOCUMENTS = {
  termsPortalPage: {
    title: "規約集",
    url: "https://2ndhome.sa-nu.com/terms",
  },
  termsOfUse: {
    title: "SANU 2nd Home 利用規約",
    url: "https://2ndhome.sa-nu.com/terms/terms-of-use",
  },
  termsForTrial: {
    title: "SANU 2nd Home Trial 利用規約",
    url: "https://2ndhome.sa-nu.com/terms/terms-for-trial",
  },
  businessTermsOfUse: {
    title: "SANU 2nd Home for Business 利用規約",
    url: "https://2ndhome.sa-nu.com/business_terms/terms-for-business",
  },
  privacyPolicy: {
    title: "SANU 2nd Home プライバシーポリシー",
    url: "https://2ndhome.sa-nu.com/terms/privacy-policy",
  },
  businessPrivacyPolicy: {
    title: "SANU 2nd Home for Business プライバシーポリシー",
    url: "https://2ndhome.sa-nu.com/business_terms/privacypolicy-for-business",
  },
  cancelFeePolicy: {
    title: "キャンセル料金のルールについて",
    url: "https://2ndhome.sa-nu.com/terms/appendix#cancel-fee",
  },
  cancelFeePolicyOfCoOwners: {
    title: "キャンセル料金のルールについて",
    url: "https://help.sa-nu.com/hc/ja/articles/26994757985049-%E4%BA%88%E7%B4%84%E3%81%AE%E3%82%AD%E3%83%A3%E3%83%B3%E3%82%BB%E3%83%AB%E3%83%9D%E3%83%AA%E3%82%B7%E3%83%BC%E3%82%92%E7%9F%A5%E3%82%8A%E3%81%9F%E3%81%84",
  },
  accommodationTerms: {
    title: "SANU 2nd Home 宿泊約款",
    url: "https://2ndhome.sa-nu.com/terms/accommodation-terms",
  },
  accommodationTermsForTrial: {
    title: "SANU 2nd Home Trial 宿泊約款",
    url: "https://2ndhome.sa-nu.com/terms/accommo-for-trial",
  },
  accommodationTermsForBusiness: {
    title: "SANU 2nd Home for Business 宿泊約款",
    url: "https://2ndhome.sa-nu.com/terms/accommo-for-business",
  },
  legalNotice: {
    title: "SANU 2nd Home 特定商取引法に基づく表記",
    url: "https://2ndhome.sa-nu.com/terms/legal-notice",
  },
  withDogs: {
    title: "愛犬同伴利用規則",
    url: "https://2ndhome.sa-nu.com/terms/with-dogs",
  },
  evCharger: {
    title: "EV充電器利用規則",
    url: "https://2ndhome.sa-nu.com/terms/ev-charger",
  },
  sauna: {
    title: "サウナ利用規則",
    url: "https://2ndhome.sa-nu.com/terms/sauna",
  },
  appendix: {
    title: "料金及び拠点に関する別表",
    url: "https://2ndhome.sa-nu.com/terms/appendix",
  },
  coOwnersCancelPolicy: {
    title: "キャンセルポリシー",
    url: "https://sanu.notion.site/232d14f248a8801cb764f45410a32204",
  },
  termOfFire: {
    title: "火器取扱規則",
    url: "https://2ndhome.sa-nu.com/terms/fire",
  },
};

// 会社のページ
export const COMPANY_URL = "https://corp.sa-nu.com/";

// FAQ お問い合わせページ
export const FAQ_CONTACT_URL = "https://help.sa-nu.com/hc/ja";

// ソーシャルログインのヘルプページ
export const SOCIAL_LOGIN_HELP_URL =
  "https://help.sa-nu.com/hc/ja/sections/56796356442521";

// サブスク入会金
// Stripe 上の Price が正式な情報だが、ページレンダリング時に取ってくるのはヘビーなので一旦こちらで定義する。
export const STANDARD_SUBSCRIPTION_APPLICATION_FEE = 55000;

// 急ぎの場合の問い合わせ先
export const SUPPORT_PHONE_NUMBER = "050-1807-2687";

// サポートセンター（問い合わせフォーム）
export const SUPPORT_CENTER_INQUIRY_FORM_URL =
  "https://help.sa-nu.com/hc/ja/requests/new";

// 法人の問い合わせフォーム
export const BUSINESS_CONTACT_FORM_URL =
  "https://vv5b8p25pa5.typeform.com/to/R7Kana88?typeform-source=www.sa-nu.com";

// ゲストご宿泊ガイド
export const GUEST_STAY_GUIDE_URL =
  "https://sanu.notion.site/27fd14f248a880e0b6cccc0c00ade48c";

// 宿泊税/入湯税 FAQ
export const LOCAL_TAX_FAQ_URL =
  "https://help.sa-nu.com/hc/ja/articles/58072883568153-%E5%AE%BF%E6%B3%8A%E7%A8%8E%E3%81%A8%E3%81%AF%E4%BD%95%E3%81%A7%E3%81%99%E3%81%8B";

// 標準最大連泊数
export const STANDARD_MAX_NIGHTS_PER_STAY = 4;

// 当日予約終了の時刻
export const RESERVATION_CLOSE_THRESHOLD_HOUR = 15;
// Nヶ月先予約開放の時刻
export const RESERVATION_OPEN_THRESHOLD_HOUR = 12;

// TODO: https://github.com/sa-nu/2h/issues/1204 設計上、BE の reservation-rule.ts と共通化しているほうが良い
// 非オーナーの予約リード月数は getDefaultReservationLeadMonths() (transition-aware)。
export const RESERVATION_LEAD_MONTHS = {
  OWNER: 6,
  INTERNAL: 12,
};

// 非オーナーのデフォルト予約リード月数。BE の実効可能範囲が 2026-10-01 を境に
// 3→6 に広がるためそれに追随する。cleanup: RRU-102 の全面 cutover 完了で
// LEGACY 分岐は dead code 化 → 定数 6 へ。
const NEW_RULE_FIRE_DATE = RESERVATION_RULE_REVISION_2027_START_DATE;
const NEW_LEAD_MONTHS = 6;
const LEGACY_LEAD_MONTHS = 3;

export function getDefaultReservationLeadMonths(
  today: PlainDate = getCurrentDate(),
): number {
  return PlainDate.compare(today, NEW_RULE_FIRE_DATE) >= 0
    ? NEW_LEAD_MONTHS
    : LEGACY_LEAD_MONTHS;
}

// 日本の郵便番号（半角ハイフン入りも許容する）
export const REGEX_OF_JAPAN_POSTAL_CODE = new RegExp(
  `^(\\d{3}-\\d{4}|\\d{7})$`,
);

// 日本の郵便番号の長さ（ハイフンを除く）
export const LENGTH_OF_JAPAN_POSTAL_CODE = 7;

// 予約フォームのデフォルト値
export const RESERVATION_FORM_DEFAULT_VALUES = {
  bringDog: true,
  numberOfDogs: 1,
  useEvCharger: false,
};

// ヘッダ要素を隠すページのパス
// 前方一致でマッチするページはヘッダ要素が表示されない
export const PAGES_WITH_HIDDEN_HEADER_ELEMENTS: string[] = [
  "/architectures",
  "/ticket-reservations",
  "/public",
  "/auth",
  "/invitation",
  "/tentative-reservations",
  "/business/signup",
  "/co-owners/entry",
  "/co-owners/pre-application",
  "/co-owners/applications",
  "/checkin-time",
  "/trial-subscription",
  "/link-account",
];

// ヘッダ要素を隠すページのパス（完全一致のみ、サブパスには適用しない）
export const PAGES_WITH_HIDDEN_HEADER_ELEMENTS_EXACT: string[] = ["/checkin"];

// スペース省略のため、ヘッダーに予約情報を表示しないパス(モバイル版のみ)
export const PAGES_WITH_HIDDEN_HEADER_ELEMENTS_IN_MOBILE: string[] = [
  "/reservation-form",
  "/ticket-reservations",
  "/tentative-reservations",
  // TODO(DXPJ-73): HeaderReservationActions の空時折りたたみで撤廃する暫定対応。
  "/areas",
];

// グローバルフッターを表示しないパス (前方一致)。
// /areas 配下は footer を右カラム内 (DxPaneFooter) に描画するため重複を避ける。
export const PAGES_WITH_HIDDEN_GLOBAL_FOOTER: string[] = ["/areas"];

// グローバルヘッダーの固定表示(sticky)を SP のみ解除するパス (前方一致)。
// (default)/layout.tsx のグローバルヘッダーと BrowseLayout の SP 検索バーの
// 両方がこのリストを参照し、SP でのオフセット/sticky を出し分ける。
export const PAGES_WITH_UNSTICKY_HEADER_IN_MOBILE: string[] = [
  "/ticket-reservations/form",
];

export type NoCancelOptionConfig = {
  stayTicketTemplateLookupKey: string;
  // TODO: 割引率は noCancel マスタの料金ポリシー（base_accommodation_fee_policies）で決まるが、
  // 公開スキーマに無いため FE で持っている。BE から返却するようにしたら置き換える
  discountLabel: string;
};

// guaranteedPriceの泊数合計を確定金額として提示してよいStayTicketMasterの一覧。
// base側にもlookupKeyを持たせるのは、base側の空き状況取得と/ticket-issueでのbase側unit発行に使うため。
// noCancelOption: null のエントリは、キャンセル不可オプション非対象だが確定金額表示のみ対象のStay ticket。
export const STAY_TICKET_MASTER_CONFIG: {
  base: { stayTicketMasterId: string; stayTicketTemplateLookupKey: string };
  noCancelOption: NoCancelOptionConfig | null;
}[] = [
  {
    // Stay_公式サイト
    base: {
      stayTicketMasterId: "019f463f-24fc-74fa-820e-a0f00d9b04dd",
      stayTicketTemplateLookupKey: "stay-site-260709",
    },
    noCancelOption: {
      stayTicketTemplateLookupKey: "stay-site-260709-no-cancel",
      discountLabel: "10%OFF",
    },
  },
  {
    // Stay_公式サイト
    base: {
      stayTicketMasterId: "019eea08-eea0-75de-85dc-2164c27c7bd0",
      stayTicketTemplateLookupKey: "stay-site-260415",
    },
    noCancelOption: {
      stayTicketTemplateLookupKey: "stay-site-260415-no-cancel",
      discountLabel: "10%OFF",
    },
  },
  {
    // Stay_LINE予約
    base: {
      stayTicketMasterId: "019eee7e-611e-7302-87f0-00b8dc3784dc",
      stayTicketTemplateLookupKey: "line-stay-251218",
    },
    // TODO(DEV-1002): /ticket-issue で発行し直すチケットに LINE ID が引き継がれず LINE ユーザーとの紐付けが切れるため、
    // DEV-1002 が解決されるまでキャンセル不可オプションを有効にしない。
    noCancelOption: null,
  },
];
